export default __webpack_public_path__ + "static/14_32-62c212e77bca76420c4f1bed4200bba2.png";